module.exports = __webpack_public_path__ + "img/tongdian1@2x.40be6642.png";